import Noticias from "../views/Noticias/Noticias";
import MainConsultas from "../views/Consultas/MainConsultas";

const Consulta = [
    {
        path: "/noticias",
        name: "Noticias",
        icon: "pe-7s-news-paper",
        component: Noticias,
        color:"#424242"
      },
      {
        path: "/consultas",
        name: "Consultas",
        icon: "pe-7s-study",
        component: MainConsultas,
        color:"#424242"
      },
];

export default Consulta;


// WEBPACK FOOTER //
// ./src/routes/Consulta.jsx